<div class="cb-margin flex-row flex">
    <div class="cb-margin flex-col flex" [cbInfiniteScroll]="leftContainer">
        <span class="mat-body-strong cb-margin-bottom">Assigned Design Changes</span>
        <div
            #leftContainer
            class="scroll-container flex-col"
            cdkDropList
            [id]="'assignedList'"
            [cdkDropListData]="assignedChangeRecords"
            [cdkDropListConnectedTo]="['unassignedList']"
            (cdkDropListDropped)="drop($event)"
        >
            @if (!assignedChangeRecords || assignedChangeRecords.length < 1) {
                <cb-info-message
                    class="cb-margin"
                    [message]="'There are no assigned change records'"
                    [icon]="'info_circle'"
                ></cb-info-message>
            }
            @for (changeRecord of assignedChangeRecords; track changeRecord) {
                <mat-card class="cb-margin flex-col" cdkDrag>
                    <mat-card-content>
                        <mat-checkbox
                            style="padding: 0"
                            [indeterminate]="
                                changeRecord.statusId ===
                                WORKING_DRAWING_CHANGE_STATUS_ENUM.NotDoing
                            "
                            [checked]="
                                changeRecord.statusId ===
                                WORKING_DRAWING_CHANGE_STATUS_ENUM.Completed
                            "
                            (click)="$event.stopPropagation()"
                            [disabled]="true"
                        >
                            Change Number: {{ changeRecord.changeNumber }}
                        </mat-checkbox>
                        <br />
                        <span>Change Details: {{ changeRecord.changeRecordDetails }}</span>
                    </mat-card-content>
                </mat-card>
            }
        </div>
    </div>
    <mat-divider class="cb-margin" [vertical]="true"></mat-divider>
    <div class="cb-margin flex-col flex" [cbInfiniteScroll]="rightContainer">
        <span class="mat-body-strong cb-margin-bottom">Unassigned Design Changes</span>
        <div
            #rightContainer
            class="scroll-container flex-col"
            cdkDropList
            [id]="'unassignedList'"
            [cdkDropListData]="unassignedChangeRecords"
            [cdkDropListConnectedTo]="['assignedList']"
            (cdkDropListDropped)="drop($event)"
        >
            @if (!unassignedChangeRecords || unassignedChangeRecords.length < 1) {
                <cb-info-message
                    class="cb-margin"
                    [message]="'There are no unassigned change records'"
                    [icon]="'info_circle'"
                ></cb-info-message>
            }
            @for (changeRecord of unassignedChangeRecords; track changeRecord) {
                <mat-card class="cb-margin flex-col" cdkDrag>
                    <mat-card-content>
                        <span>Change Number: {{ changeRecord.changeNumber }}</span>
                        <br />
                        <span>Change Details: {{ changeRecord.changeRecordDetails }}</span>
                    </mat-card-content>
                </mat-card>
            }
        </div>
    </div>
</div>
